import { createSelector } from '@reduxjs/toolkit';

/**
 * Memoized selector that combines all AmpolCash Order Modal data.
 * Prevents unnecessary re-renders by only updating when actual data changes.
 */
export const selectAmpolCashOrderModalContext = createSelector(
  [(state: any) => state.userStore, (state: any) => state.cashStore, (state: any) => state.maintenanceStore],
  (userStore, cashStore, maintenanceStore) => ({
    // User context (3 fields)
    assignedGrandfatherClientNumber: userStore.assignedGrandfatherClientNumber,
    loggedInUser: userStore.loggedInUser,
    assignedAccountNumber: userStore.assignedAccountNumber,
    isAdmin: userStore.isAmpolAdmin,

    // Cash order defaults and loading (3 fields)
    cashOrderDefaults: cashStore.cashOrderDefaults,
    cashOrderDefaultsLoading: cashStore.cashOrderDefaultsLoading,
    cashOrderDefaultsError: cashStore.cashOrderDefaultsError,

    // Plastic types loading (2 fields)
    plasticTypesListLoading: maintenanceStore.plasticTypesListLoading,
    plasticTypesListError: maintenanceStore.plasticTypesListError,

    // Cart and order data (2 fields)
    cashOrderCartItems: cashStore.cashCartItems,
    cashCartSubTotal: cashStore.cashCartSubTotal,

    // Delivery options (3 fields)
    deliveryOption: cashStore.cashOrderDeliveryOption,
    singleShippingAddress: cashStore.cashOrderSingleShippingAddress,
    physicalAddressRecipient: cashStore.cashOrderPhysicalAddressRecipient,

    // Shipping and fees (7 fields)
    shippingMethod: cashStore.cashCartShippingMethod,
    isFeeWaiveOverride: cashStore.isFeeWaiveOverride,
    promoDiscount: cashStore.cashCartDiscount,
    requestedName: cashStore.cashCartRequestedName,
    requestedPhone: cashStore.cashCartRequestedPhone,
    caseNumber: cashStore.cashCartCaseNumber,
    purchaseOrderNumber: cashStore.cashCartPurchaseOrderNumber,

    // Order creation state (2 fields)
    createCashOrderLoading: cashStore.createCashOrderLoading,
    createCashOrderResponse: cashStore.createCashOrderResponse,

    // Modal step state (1 field)
    stepId: cashStore.cashModalStepId,

    // Composite loading state - true if any loading operation is in progress
    isModalLoading:
      cashStore.cashOrderDefaultsLoading ||
      maintenanceStore.plasticTypesListLoading ||
      cashStore.createCashOrderLoading,

    // Composite error state - true if any error exists
    hasErrors: !!(cashStore.cashOrderDefaultsError || maintenanceStore.plasticTypesListError),

    // Ready to open modal - no loading and no errors
    isReadyToOpen:
      !cashStore.cashOrderDefaultsLoading &&
      !maintenanceStore.plasticTypesListLoading &&
      !cashStore.cashOrderDefaultsError &&
      !maintenanceStore.plasticTypesListError,
  })
);
